import { render, staticRenderFns } from "./RightToWorkDetails.vue?vue&type=template&id=5e895562&scoped=true&"
import script from "./RightToWorkDetails.vue?vue&type=script&lang=js&"
export * from "./RightToWorkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e895562",
  null
  
)

export default component.exports